// Carousel.js
import React from 'react';
import Slider from 'react-slick';
import { Card, CardContent, Typography, IconButton } from '@mui/material';
import { styled } from '@mui/system';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import '../style/card_carousel.css'
import img1 from "../images/cardsImg/1.png";
import img2 from "../images/cardsImg/2.png";
import img3 from "../images/cardsImg/3.png";
import img4 from "../images/cardsImg/4.png";
import img5 from "../images/cardsImg/5.png";

// Example data
const _items = [
  {
    player: {
      title: 'Infinity Floral Diamond Mangalsutra',
      price: '₹  57594',
      image: img1,
    },
  },
  {
    player: {
      title: 'Infinity Floral Diamond Mangalsutra',
      price: '₹  57594',
      image: img2,
    },
  },
  {
    player: {
      title: 'Infinity Floral Diamond Mangalsutra',
      price: '₹  57594',
      image: img3,
    },
  },
  {
    player: {
      title: 'Infinity Floral Diamond Mangalsutra',
      price: '₹  57594',
      image: img4,
    },
  },
  {
    player: {
      title: 'Infinity Floral Diamond Mangalsutra',
      price: '₹  57594',
      image: img5,
    },
  },
];

// Styled components
const CarouselCard = styled(Card)({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'relative',
  overflow: 'hidden',
  // '& img': {
  //   width: '100%',
  //   height: '100%',
  //   objectFit: 'cover',
  //   transition: 'transform 0.5s ease',
  // },
  '&:hover img': {
    transform: 'scale(1.1)',
  },
});

const CustomArrow = styled(IconButton)(({ direction }) => ({
  marginLeft: '-90px',
  marginRight: '-90px',
  position: 'absolute',
  top: '50%',
  zIndex: 1,
  transform: 'translateY(-50%)',
  backgroundColor: '#7b7b7b29',
  borderRadius: '50%',
  width: '3rem',
  height: '3rem',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)',
  '& svg': {
    fontSize: '1rem',
    marginLeft: '3px',
  },
  ...(direction === 'left' ? { left: '1rem' } : { right: '1rem' }),
}));

// Custom Next Arrow Component
const NextArrow = (props) => {
  const { onClick } = props;
  return (
    <CustomArrow direction="right" onClick={onClick}>
      <ArrowForwardIosIcon />
    </CustomArrow>
  );
};

// Custom Prev Arrow Component
const PrevArrow = (props) => {
  const { onClick } = props;
  return (
    <CustomArrow direction="left" onClick={onClick}>
      <ArrowBackIosIcon />
    </CustomArrow>
  );
};

// Carousel component
export default function CardCarousel() {
  // Slick slider settings
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  return (
    <div className='content_box' style={{ width: '90%', margin: 'auto', marginTop: '2rem', position: 'relative' }}>
      <Slider {...settings}>
        {_items.map((item, idx) => (
          <CarouselCard key={idx}>
            <img src={item.player.image} alt={item.player.title} />
            <CardContent>
              <Typography variant="h6" component="div" style={{fontSize: '1rem'}}>
                {item.player.title}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {item.player.price}
              </Typography>
            </CardContent>
          </CarouselCard>
        ))}
      </Slider>
    </div>
  );
}
